<site-header></site-header>

<ion-content>
  <div class="page-background ion-padding" id="main-container" ion-fixed>
    <div id="main" class="">
      <div class="aligner-item"><h1>common page</h1></div>
    </div>
  </div>
  <site-footer></site-footer>
</ion-content>
